
import messages from './messages/overhangMessages';
import BarWaterfall1Small90Deg from './images/overhangs/Bar_waterfall_1_384x212.png';
import BarWaterfall1Big90Deg from './images/overhangs/Bar_waterfall_1_500x500.png';
import BarWaterfallPictogram from './images/overhangs/Pictograms/picto_PLAN_bar_waterfall.png';
import BarWaterfall1Small45Deg from './images/overhangs/Bar_waterfall_90_1_384x212.png';
import BarWaterfall1Big45Deg from './images/overhangs/Bar_waterfall_90_1_500x500.png';
import { NO_OVERHANG_ID } from './overhangs';

const availableOverhangs = {
  noOverhang: {
    id: NO_OVERHANG_ID,
    displayName: messages.noWaterfall,
  },
  'waterfall-45-degrees': {
    displayName: messages.waterfall45Degrees,
    displayImage: BarWaterfall1Small45Deg,
    displayImageLarge: BarWaterfall1Big45Deg,
    pictogramImage: BarWaterfallPictogram,
  },
  'waterfall-90-degrees': {
    displayName: messages.waterfall90Degrees,
    displayImage: BarWaterfall1Small90Deg,
    displayImageLarge: BarWaterfall1Big90Deg,
    pictogramImage: BarWaterfallPictogram,
  },
};

const kitchenIslandOverhangOptions = (overhangs) => {
  return [availableOverhangs.noOverhang].concat(
    overhangs.filter((overhang) => {
      if (!availableOverhangs[overhang.id]) {
        return false;
      }

      if (!overhang.allowedMaterials || overhang.allowedMaterials.length === 0) {
        // eslint-disable-next-line no-console
        console.error('Excluding kitchen island overhang', overhang.id, 'due to no allowed materials:', overhang.id);
        return false;
      }

      return true;
    })
    .map(({ id, allowedMaterials, minLength }) => ({
      id,
      allowedMaterials,
      minLength,
      ...availableOverhangs[id],
    }))
  );
};

export function generateKitchenIslandOverhangs({ overhangs }) {
  const includeOverhangs = overhangs && overhangs.length !== 0;

  if (!includeOverhangs) {
    return [availableOverhangs.noOverhang];
  }

  return kitchenIslandOverhangOptions(overhangs);
}
